import * as Observe from 'src/state/lib/observe';

export const QueryParamsValue = Observe.Value<{
  [key: string]: undefined | string | string[];
}>({});
